// src/components/Header.js
import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import "./header.css";
import SonusLogo from "../../assets/img/sonus-logo.png";

const Header = () => {
    return (

        <nav className="flex flex-wrap justify-between w-full p-2 items-start h-fit bg-primary" style={{ padding: "1rem 2rem" }}>
            <div className="flex gap-2 items-center" style={{width: "100%"}}>
                <a href="/" style={{display: "flex", alignItems: "center", fontSize: "1.5rem", fontWeight: "200", letterSpacing: "3px"}}>
                    <img
                        alt="Sonus"
                        loading="lazy"
                        width={42}
                        height={42}
                        decoding="async"
                        data-nimg={1}
                        className="mr-4"
                        style={{ color: "transparent" }}
                        src={SonusLogo}
                    />
                    Sonus
                </a>
                <div style={{ display: 'flex', gap: 20, alignItems: 'center', marginLeft: '20px', paddingTop: '5px', fontWeight: 300 }}> 
                    <a href="/claim" className="nav-link">Claim</a>
                    <a href="/checker" className="nav-link">Checker</a>
                </div>
                <div className="md:flex md:gap-2 grid gap-1 items-center" style={{ alignSelf: 'center', flex: "1", display: "flex", justifyContent: "flex-end" }}>
                    <div className="grid justify-items-end items-center" style={{width: "100%"}}>
                        <ConnectButton.Custom>
                            {({
                                account,
                                chain,
                                openAccountModal,
                                openChainModal,
                                openConnectModal,
                                authenticationStatus,
                                mounted,
                            }) => {
                                // Note: If your app doesn't use authentication, you
                                // can remove all 'authenticationStatus' checks
                                const ready = mounted && authenticationStatus !== 'loading';
                                const connected =
                                    ready &&
                                    account &&
                                    chain &&
                                    (!authenticationStatus ||
                                        authenticationStatus === 'authenticated');

                                return (
                                    <div
                                        {...(!ready && {
                                            'aria-hidden': true,
                                            'style': {
                                                opacity: 0,
                                                pointerEvents: 'none',
                                                userSelect: 'none',
                                            },
                                        })}
                                    >
                                        {(() => {
                                            if (!connected) {
                                                return (
                                                    <button
                                                        className="connectButton"
                                                        type="button"
                                                        aria-haspopup="dialog"
                                                        aria-expanded="false"
                                                        onClick={openConnectModal}
                                                        aria-controls="radix-:r3:"
                                                        data-state="closed"
                                                    >
                                                        Connect Wallet
                                                    </button>

                                                );
                                            }

                                            if (chain.unsupported) {
                                                return (
                                                    <button
                                                        className="connectButton"
                                                        type="button"
                                                        aria-haspopup="dialog"
                                                        aria-expanded="false"
                                                        onClick={openChainModal}
                                                        aria-controls="radix-:r3:"
                                                        data-state="closed"
                                                    >
                                                        Wrong Network
                                                    </button>
                                                );
                                            }

                                            return (
                                                // <div className='text-white text-sm' style={{ display: 'flex', gap: 12 }}>
                                                    <button onClick={openAccountModal} type="button" style={{ alignSelf: 'center', flex: "1", display: "flex", justifyContent: "flex-end" }}>
                                                        <div className="accountDetails">
                                                            <div>{account.displayName}</div>
                                                        </div>
                                                    </button>
                                                // </div>
                                            );
                                        })()}
                                    </div>
                                );
                            }}
                        </ConnectButton.Custom>
                    </div>
                </div>
            </div>
        </nav>

    );
};

export default Header;
